import * as React from 'react';
import { PageOverlay } from '../../components/PageOverlay/styles';
import { OfflineManagerState } from '../OfflineManager/reducer';
import { AppInfosState, AppType } from '../App/reducer';
import { GalleryInfosState } from '../Gallery/reducer';
import { StoreState } from '../../reducers';
import { connect, Dispatch } from 'react-redux';
import DownloadAllPopupContent from '../../components/DownloadAllPopupContent';
import { StyledDownloadAllPopup } from './styles';
import { DownloadAllPopupState as DownloadAllPopupStoreState } from './reducer';
import { closeDownloadAllPopup } from './actions';
import UserAgentUtils from '../../utils/userAgent';
import DownloadManagerUtils from '../../utils/downloadManager';
import { DriveListState } from '../DriveItemList/reducer';
import { DownloadManagerState } from '../DownloadManager/reducer';
import { downloadAll } from '../DownloadManager/actions';
import Utils from '../../utils';

interface DownloadAllPopupProps {
	dispatch: Dispatch<StoreState>;
	appInfos: AppInfosState;
	galleryInfos: GalleryInfosState;
	offlineManager: OfflineManagerState;
	downloadAllPopup: DownloadAllPopupStoreState;
	driveList: DriveListState;
	downloadManager: DownloadManagerState;
}

interface DownloadAllPopupState {
	isDontAskMeAgainChecked: boolean;
}


class DownloadAllPopup extends React.Component<DownloadAllPopupProps, DownloadAllPopupState> {

	constructor() {
		super();
		this.close = this.close.bind(this);
		this.startDownloadAll = this.startDownloadAll.bind(this);
		this.onCheckboxChange = this.onCheckboxChange.bind(this);

		this.state = {
			isDontAskMeAgainChecked: false,
		};
	}

	close() {
		const { dispatch } = this.props;
		const { isDontAskMeAgainChecked } = this.state;
		dispatch(closeDownloadAllPopup(isDontAskMeAgainChecked));
	}

	onCheckboxChange(e: React.ChangeEvent<HTMLInputElement>) {
		this.setState({
			isDontAskMeAgainChecked: e.target.checked
		});
	}

	startDownloadAll() {
		const { dispatch } = this.props;
		dispatch(downloadAll());
		this.close();
	}

	render() {
		const { appInfos, galleryInfos, offlineManager, downloadAllPopup: { closedByUser }, downloadManager, driveList } = this.props;
		const { isDontAskMeAgainChecked } = this.state;
		const appType = appInfos.type as AppType;
		const isGalleryReady = Utils.isGalleryReady(galleryInfos, offlineManager, appType);
		const { isMobileApp } = UserAgentUtils;
		const { config } = galleryInfos;

		const isDisabled = config && config.downloadAllPopup && config.downloadAllPopup.enabled === false;

		const hasItemsToDownload = DownloadManagerUtils.hasItemsToDownload(downloadManager, driveList, galleryInfos);

		const isPopupOpened = isMobileApp
			&& isGalleryReady && !galleryInfos.forceSplashScreen
			&& hasItemsToDownload
			&& !closedByUser
			&& !isDisabled;

		return (
			<StyledDownloadAllPopup>
				<PageOverlay isOpen={isPopupOpened} onClick={this.close} />
				{
					isPopupOpened && <DownloadAllPopupContent
						startDownloadAll={this.startDownloadAll}
						isDontAskMeAgainChecked={isDontAskMeAgainChecked}
						onCheckboxChange={this.onCheckboxChange}
						close={this.close}
					/>
				}
			</StyledDownloadAllPopup>
		);
	}
}

const mapStateToProps = (state: StoreState) => {
	const { appInfos, galleryInfos, offlineManager, downloadAllPopup, driveList, downloadManager } = state;
	return { appInfos, galleryInfos, offlineManager, downloadAllPopup, driveList, downloadManager };
};

export default connect(mapStateToProps)(DownloadAllPopup);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DownloadAllPopup/index.tsx